import React, {useEffect, useRef, useState} from 'react';
import {Tooltip} from '@enos/dpl';
import './index.less';

export default function MessageBody(props) {
  const spanMessageRef = useRef();

  const [title, setTitle] = useState('');

  useEffect(() => {
    if (spanMessageRef.current.scrollWidth > props.width && title !== props.item) {
      setTitle(props.item);
    }

    if (spanMessageRef.current.scrollWidth <= props.width && title !== props.item) {
      setTitle('');
    }
  });

  return (
    <div className='body'>
      <Tooltip overlayClassName='message-body' title={title}>
        <span style={{display: 'inline-block'}} ref={spanMessageRef}>
          {props.item}
        </span>
      </Tooltip>
    </div>
  );
}
